<ng-container *transloco="let t; prefix: 'aboutUs'">
	<section class="container lg:px-[72px] mb-6 md:mb-20">
		<div class="w-full mt-10 md:mt-12">
			<h2 class="text-center text-black rfs:text-5xl mb-6"> {{ t("title") }} </h2>
		</div>
		@if (isMobile$ | async) {
			<div
				[ngStyle]="{'transform': 'scale(1)'}"
				style="height: auto; aspect-ratio: 16 / 9;"
				class="w-full bg-contain bg-[url('./assets/img/about-us-hero.png')] bg-no-repeat rounded-md inline-flex justify-center">
			</div>
		} @else {
			<div
				imageScrollAnimation
				[ngStyle]="{'transform' : 'scale(0.7)'}"
				class="w-full h-[488px] bg-cover bg-[url('./assets/img/about-us-hero.png')] bg-no-repeat rounded-md inline-flex justify-center">
			</div>
		}

	</section>

	<section class="container lg:px-[179px] mb-6 md:mb-20">
		<div class="w-full mx-auto mt-6">
			<p class="text-center text-black text-2xl mt-6"> {{ t("subtitle") }} </p>
		</div>
		<div class="w-full mx-auto mt-6 md:mt-12">
			<p class="text-center text-gray-900 mt-6"> {{ t("description") }} </p>
		</div>
	</section>

	<section class="container lg:px-[179px] mb-6 md:mb-20">
		<div class="p-6 bg-[#FFEFE8] rounded-xl flex flex-col justify-center items-center gap-6 mt-20">
			<div class="self-stretch justify-start items-start gap-1 inline-flex">
				<img src="./assets/svgs/opening-quote.svg" alt="open quote">
			</div>
			<div class="self-stretch text-center text-black text-xl">
				{{t('blockQuote')}}</div>
			<div class="self-stretch justify-end items-end gap-1 inline-flex">
				<img src="./assets/svgs/closing-quote.svg" alt="close quote">
			</div>
		</div>
	</section>

	<section class="container lg:px-[179px] mb-6 md:mb-20 space-y-6">
		<div class="mx-auto mt-20">
			<h2 class="text-left text-black rfs:text-4xl mb-8"> {{ t("ourValues.title") }}</h2>
			<p class="text-left text-gray-900"> {{ t("ourValues.description") }} </p>
		</div>

		@for (value of values; track $index) {
		<div class="p-8 w-full flex flex-col md:flex-row bg-white rounded-xl justify-start items-start gap-6 md:inline-flex">
			<button type="buton"
				class="md:hidden flex flex-row w-full justify-between"
				(click)="toggleAccordion($index)">
				<img class="w-20 h-20" [src]="value.img" />
				@if (isMobile$ | async) {
					<div
						class="h-[50px] pt-[30px] justify-center items-center gap-2 flex cursor-pointer"
						(click)="toggleAccordion($index)">
						<div
							class="h-5 relative rotate-0 transition-all text-end self-start"
							[ngClass]="{ 'rotate-180': currentAccordionIndex === $index }">
							<i [ngClass]="{'icon-minus' : currentAccordionIndex === $index }" class="icon-plus text-primary-700"></i>
						</div>
					</div>
				}
			</button>
			<img class="hidden md:block w-20 h-20" [src]="value.img" />
			<div class="grow shrink basis-0 pt-6 flex-col justify-start items-start gap-4 inline-flex">
				<button
					type="buton"
					(click)="toggleAccordion($index)"
					class="w-full text-left font-semibold text-black rfs:text-2xl rotate-0 transition-all"> {{ t(value.title) }}
				</button>
				<div class="self-stretch text-gray-900 overflow-hidden" [ngClass]="{ 'h-0': currentAccordionIndex != $index }"> {{
					t(value.description) }} </div>
			</div>
			<div class="hidden md:block h-[50px] pt-[30px] justify-center items-center gap-2 flex">
				<div
					class="h-5 relative rotate-0 transition-all text-end self-start cursor-pointer"
					[ngClass]="{ 'rotate-180': currentAccordionIndex === $index }"
					(click)="toggleAccordion($index)">
					<i [ngClass]="{'icon-minus' : currentAccordionIndex === $index }" class="icon-plus text-primary-700"></i>
				</div>
			</div>
		</div>
		}
	</section>

	<section class="container lg:px-[179px] mb-6 md:mb-20">
		<div class="mx-auto mt-20">
			<h2 class="text-left text-black rfs:text-4xl mb-8"> {{ t("coop.title") }}</h2>
			<p class="text-left text-gray-900"> {{ t("coop.description") }} </p>
		</div>

		<div class="mt-14 bg-secondary-50 border-2 rounded-xl border-secondary-500 px-4 md:px-6 pt-4 pb-6 md:pb-8 space-y-6">
			<div class="w-full p-1 border-full border border-gray-500 flex flex-row rounded-full">
				@for (tab of tabs; track $index) {
					<button
					  class="tab-pill flex-1 justify-center"
					  type="button"
					  [ngClass]="{ active: selectedTab === $index + 1 }"
					  (click)="toggleSwitch($index+ 1)"
					>
						<img class="w-[76.11px] h-7" [src]="selectedTab === $index + 1 ? tab.img[0] : tab.img[1]" [alt]="tab.alt">
					</button>
				}
			</div>

			<div class="grid">
				@if (selectedTab === 1) {
					<p class="text-left text-gray-900"> {{ t("coop.tab.qualco") }} </p>
				} @else {
					<p class="text-left text-gray-900"> {{ t("coop.tab.nbg") }} </p>
				}
			</div>
		</div>
	</section>

	@if (!isProduction) {
	<section class="container lg:px-[179px] mb-6 md:mb-20 space-y-6 hidden">
		<div class="mx-auto mt-20">
			<h2 class="text-left text-black rfs:text-4xl mb-8"> Οι άνθρωποί μας</h2>
		</div>
		<app-people-list-swiper [swiperItems]="swiperItems"></app-people-list-swiper>
	</section>
	}
</ng-container>
